import axios from 'axios'

const buildUrl = (url) => {
  let final = process.env.REACT_APP_API_EXPDATA_ROOT
  if (!url.startsWith('/')) {
    final += '/'
  }
  final += url
  return final
}

const getFormData = object => Object.keys(object).reduce((formData, key) => {
  formData.append(key, object[key])
  return formData
}, new FormData())

const PrivateAPI = {
  get: (url, query) => {
    return axios({
      method: 'get',
      url: buildUrl(url),
      headers: {
        'Authorization': 'Api-Key ' + process.env.REACT_APP_EXPDATA_API_KEY
      },
      params: query
    })
  },

  post: (url, payload) => {
    return axios({
      method: 'post',
      url: buildUrl(url),
      data: payload,
      headers: {
        'Authorization': 'Api-Key ' + process.env.REACT_APP_EXPDATA_API_KEY
      }
    })
  },

  postfile: function (url, payload) {
    const formData = getFormData(payload)
    return axios({
      method: 'post',
      url: buildUrl(url),
      data: formData,
      headers: {
        'Authorization': 'Api-Key ' + process.env.REACT_APP_EXPDATA_API_KEY
      }
    })
  },

  put: (url, payload) => {
    return axios({
      method: 'put',
      url: buildUrl(url),
      data: payload,
      headers: {
        'Authorization': 'Api-Key ' + process.env.REACT_APP_EXPDATA_API_KEY
      }
    })
  },

  delete: (url, payload) => {
    return axios({
      method: 'delete',
      url: buildUrl(url),
      data: payload,
      headers: {
        'Authorization': 'Api-Key ' + process.env.REACT_APP_EXPDATA_API_KEY
      }
    })
  }
}

export default PrivateAPI


